"use client";

import { useSession } from "next-auth/react";
import { useEffect } from "react";
import { useRouter } from "next/navigation";
import TwoColumnSplitLayout from "../../../components/PageLayout/TwoColumnSplitLayout";
import Benefits from "./Benefits";

const Welcome: React.FC = () => {
  const { status } = useSession();
  const router = useRouter();

  useEffect(() => {
    if (status === "authenticated") {
      // Redirect to home if the user is logged in
      router.push("/dashboard");
    }
  }, [status, router]);

  return (
    <TwoColumnSplitLayout>
      <Benefits />
    </TwoColumnSplitLayout>
  );
};

export default Welcome;
